import { useEffect } from 'react'
import { Location } from 'react-router'
import { useTranslation } from 'react-i18next'

import { Link, useNavigate } from 'features/i18n/router'
import usePageModal from 'features/Modal/hooks/usePageModal'
import { CALL_TIMELINE_TYPE } from 'features/CallTimeline/CallTimeline'

import Tabs from 'components/Tabs'

import CallList from './CallList'
import FilterCallCategory from './FilterCallCategory'

import { MODAL_MODE } from '../config'

import './style.scss'

const TIMELINE_TABS = {
  [CALL_TIMELINE_TYPE.follower]: 0,
  [CALL_TIMELINE_TYPE.all]: 1,
}

type CallListModalProps = {
  callTimelineMode?: 'follower' | 'all'
  location: Location
}

const CallListModal = ({
  location,
  callTimelineMode = 'follower',
}: CallListModalProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { generatePageModalUrl } = usePageModal()

  const currentTimeline = TIMELINE_TABS[callTimelineMode]

  return (
    <div className="Modal__wrapper CallListModal">
      <div className="Modal__header">
        <Link className="Modal__header__close" to={location.pathname} />

        <h2 className="Modal__header__h2">{t('call_list_modal.title')}</h2>
      </div>

      <div className="Modal__body">
        <FilterCallCategory callTimelineMode={callTimelineMode} />

        <Tabs
          tabs={[
            { title: t('common.following') },
            { title: t('common.public_timeline') },
          ]}
          onChange={(index) => {
            navigate(
              generatePageModalUrl(MODAL_MODE.CALL_LIST_MODAL, {
                callTimelineMode:
                  index === 1
                    ? CALL_TIMELINE_TYPE.all
                    : CALL_TIMELINE_TYPE.follower,
              })
            )
          }}
          defaultIndex={currentTimeline}
        />

        <CallList callTimelineMode={callTimelineMode} />
      </div>
    </div>
  )
}

CallListModal.defaultProps = {
  callTimelineMode: 'follower',
}

export default CallListModal
